

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const sendInvoiceApi = createAsyncThunk("sendInvoice", async ({
    _id
}) => {
    const response = await axiosInstance.get(`/sendInvoiceToPartner/${_id}`)
    return response.data;
});

const sendInvoiceSlice = createSlice({
    name: "sendInvoice",
    initialState: {
        sendInvoice: [],
        errors: [],
        loading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(sendInvoiceApi.pending, (state) => {
                state.loading = true;
            })
            .addCase(sendInvoiceApi.fulfilled, (state, action) => {
                state.sendInvoice = action?.payload;
                state.loading = false;
            })
            .addCase(sendInvoiceApi.rejected, (state, action) => {
                state.errors = action.payload;
                // state.errors.push(action.error.message);
                state.loading = false;
            });
    },
});

export default sendInvoiceSlice.reducer;
